import { useState, type FormEvent } from 'react';

import type { ShowsAnswer } from '../api';
import { Failed, Spinner, Top, useCall } from '../components/parts';
import { Link, navigate } from '../router';

// GrailFind's first page (José's pick, 23 Oct 2026): the card shows coming up, by city and day.

const shopsText = (n: number) => (n === 0 ? 'No shops listed yet' : n === 1 ? '1 shop lists its cards' : `${n} shops list their cards`);

export function ShowsPage({ query }: { query: URLSearchParams }) {
  const qs = query.toString();
  const { data, error, reload } = useCall<ShowsAnswer>(`/api/find/shows${qs ? `?${qs}` : ''}`);

  return (
    <>
      <Top />
      <main>
        <h1>Card shows</h1>
        <p className="lede">Shows coming up, and the shops that list their cards on GrailFind.</p>
        <ShowFilters key={qs} city={query.get('city') ?? ''} date={query.get('date') ?? ''} cities={data?.cities ?? []} />
        {error ? <Failed error={error} retry={reload} /> : !data ? <Spinner /> : <ShowList data={data} />}
      </main>
    </>
  );
}

function ShowFilters({ city, date, cities }: { city: string; date: string; cities: string[] }) {
  const [c, setC] = useState(city);
  const [d, setD] = useState(date);
  const submit = (e: FormEvent) => {
    e.preventDefault();
    const q = new URLSearchParams();
    if (c) q.set('city', c);
    if (d) q.set('date', d);
    navigate(`/shows${q.size ? `?${q}` : ''}`, { replace: true });
  };
  return (
    <form className="filters" onSubmit={submit}>
      <label>
        City
        <select value={c} onChange={(e) => setC(e.target.value)}>
          <option value="">Any city</option>
          {cities.map((x) => (
            <option key={x} value={x}>
              {x}
            </option>
          ))}
        </select>
      </label>
      <label>
        Open on
        <input type="date" value={d} onChange={(e) => setD(e.target.value)} />
      </label>
      <div className="acts">
        <button className="go" type="submit">
          Show
        </button>
        <Link className="clear" href="/shows">
          Clear
        </Link>
      </div>
    </form>
  );
}

function ShowList({ data }: { data: ShowsAnswer }) {
  if (data.shows.length === 0)
    return (
      <p className="empty">
        {data.filters.city || data.filters.date ? 'No shows match. Try another city or day.' : 'No shows coming up yet. Check again soon.'}
      </p>
    );
  return (
    <div className="shows">
      {data.shows.map((s) => (
        <Link key={s.slug} className="grp" href={`/s/${encodeURIComponent(s.slug)}`}>
          <div className="grp-h">
            <b>{s.name}</b>
            <span>{s.when}</span>
            {s.hours ? <span>{s.hours}</span> : null}
            <span>{shopsText(s.shops)}</span>
          </div>
          <span className="go-on">See the show</span>
        </Link>
      ))}
    </div>
  );
}
